//
//
//
//
//
//
//
//
//

export default {
  name: 'booking-pieces-hint',
  computed: {
    hint () {
      return this.$t('booking.cargo.form.piecesHint');
    },
  },
};
